import Tip from "./Tip";
import m from "../../prime-src/prepare";

export default function Manual() {
  return (
    <>
      <div className="side2">
        <div className="button" id="toggle-manual" onClick={() => m.toggleManual()}>
          ▼ Hiding Recoeve.net Manual
        </div>
      </div>
      <div className="side2" id="recoeve-manual" style={{display:'none'}}>
        <Tip/>
        <div className="p"></div>
        <div className="p">
          Recoeve.net Manual collection | 사용설명서 모음집: <a className="wheat" target="_blank" href="https://recoeve.net/user/kipid?cat=%5BRecoeve%5D--Manual%2F%EC%84%A4%EB%AA%85%EC%84%9C&PRL=0.60&PRR=1.00#headPlay">[Recoeve]--Manual/설명서</a><br />
          <a target="_blank" href="https://recoeve.net/user/kipid?cat=%5BRecoeve%5D--Manual%20in%20Korean&PRL=0.85&PRR=1.00&lang=en#headPlay">[Recoeve]--Manual in Korean</a><br />
          <a target="_blank" href="https://recoeve.net/user/kipid?cat=%5BRecoeve%5D--Manual%20in%20English&PRL=0.85&PRR=1.00&lang=en#headPlay">[Recoeve]--Manual in English</a>
        </div>
        <div className="p">
          For the usage examples, visit my pages. (예제를 보시려면 제 페이지를 방문해 주세요.)
          <ul>
            <li><a target="_blank" href="/user/kipid/mode/multireco?cat=%5BMusic%2FBreak%5D--K-Pop&PRL=0.60&PRR=1.00#headPlay">[Music/Break]--K-Pop (Multireco mode)</a></li>
            <li><a target="_blank" href="/user/kipid/mode/multireco?cat=%5BMusic%2FBreak%5D--Pop&PRL=0.60&PRR=1.00#headPlay">[Music/Break]--Pop (Multireco mode)</a></li>
            <li><a target="_blank" href="https://recoeve.net/user/kipid/mode/multireco?cat=%5BMusic%2FBreak%5D--Celebrities&PRL=0.60&PRR=1.00#headPlay">[Music/Break]--Celebrities (Multireco mode)</a></li>
            <li><a target="_blank" href="/user/kipid/mode/multireco?cat=%5BMusic%2FBreak%5D--Pet&PRL=0.80&PRR=1.00#headPlay">[Music/Break]--Pet (Multireco mode)</a></li>
            <li><a target="_blank" href="https://recoeve.net/user/kipid/mode/multireco?cat=%5BPhysics%2FMath%2FScience%5D--Physics&PRL=0.60&PRR=1.00#headPlay">[Physics/Math/Science]--Physics (Multireco mode)</a></li>
            <li><a target="_blank" href="https://recoeve.net/user/kipid/mode/multireco?cat=%5B%EC%9D%8C%EC%8B%9D%2F%EC%9A%94%EB%A6%AC%2F%EA%B1%B4%EA%B0%95%5D--%EA%B1%B4%EA%B0%95&PRL=0.80&PRR=1.00#headPlay">[음식/요리/건강]--건강 (Multireco mode)</a></li>
          </ul>
        </div>
        <div className="p">
          <span className="bold">평가와 기록</span>: 웹사이트에서 본 기사, 뉴스, 영상, 음악 등을 기록하고 평가하세요. 이 정보는 추천 알고리즘을 통해 사용자에게 맞춤형 추천을 제공하는 데 사용됩니다. 즉, 당신이 좋아하는 유형의 콘텐츠를 더 많이 발견할 수 있습니다.<br />
          <br />
          <span className="bold">Evaluate and Rate Content</span>: As you explore content on the platform, you can evaluate and rate it based on your preferences and interests. This could involve liking, rating, or commenting on articles, posts, or other types of content.<br />
          <br />
          <span className="bold">Connect with Like-Minded Users</span>: The platform likely has features for connecting with other users who share your interests. You might follow or connect with these users to build your network.
        </div>
        <div style={{margin:'2em 0 0'}}>How to use Recoeve.net and How to reco (레코이브 사용법)</div>
        <div className="rC" style={{margin:'1em 0'}}>
          <div className="rSC"><iframe delayed-src="https://www.youtube.com/embed/5E1BR8BdUCY" allowFullScreen></iframe></div>
        </div>
      </div>
    </>
  );
}
